import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SupportIcon from '@mui/icons-material/Support';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

export default function P2P() {
  const handleLiveSupport = () => {
    if (window.smartsupp) {
      window.smartsupp('chat:open');
    }
  };

  return (
    <Box sx={{ 
      width: '100%', 
      typography: 'body1', 
      marginTop: '75px', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '60vh'
    }}>
      <Card sx={{ 
        maxWidth: 600, 
        mx: 2, 
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
      }}>
        <CardContent sx={{ p: 4 }}>
          <SupportIcon sx={{ 
            fontSize: 80, 
            color: '#F7A600', 
            mb: 3,
            filter: 'drop-shadow(0 4px 8px rgba(247, 166, 0, 0.3))'
          }} />
          
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom 
            sx={{ 
              fontWeight: 700,
              color: '#1a1a1a',
              mb: 2,
              textAlign: 'center',
              lineHeight: 1.3
            }}
          >
            Need Payment Details?
          </Typography>
          
          <Typography 
            variant="h6" 
            component="p"
            sx={{ 
              color: '#666',
              mb: 4,
              textAlign: 'center',
              lineHeight: 1.6,
              maxWidth: 500
            }}
          >
            Kindly use the live support button below to get verified account details to make payment.
          </Typography>
          
          <Button 
            variant="contained" 
            size="large" 
            startIcon={<SupportIcon />}
            sx={{ 
              background: 'linear-gradient(45deg, #F7A600 30%, #FF8E53 90%)',
              color: '#fff',
              fontWeight: 700,
              borderRadius: 3,
              px: 6,
              py: 2,
              fontSize: '1.1rem',
              boxShadow: '0 6px 20px rgba(247, 166, 0, 0.4)',
              textTransform: 'none',
              '&:hover': {
                background: 'linear-gradient(45deg, #e69500 30%, #ff7a40 90%)',
                boxShadow: '0 8px 25px rgba(247, 166, 0, 0.5)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
            onClick={handleLiveSupport}
          >
            Start Live Chat
          </Button>
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#888',
              mt: 3,
              textAlign: 'center'
            }}
          >
            Our support team is available 24/7 to assist you
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
